import "./svg/flash.svg"

export default {
    name: "flash",
    viewBox: "137 41",
}
